<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
              <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
              <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                  <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                  <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                  <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                  <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                  <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                </select>
              </div>          
              <div class="box-tools">
                <button v-on:click="inquiry" class="btn btn-warning">Search</button>
              </div>
          </div>        
          <div class="box-body no-padding table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="width: 45px;text-align:right;">#</th>
                  <th style="text-align:center;">Action</th>
                  <th style="text-align:left;">Name</th>
                  <th style="text-align:center;">Using Passcode</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in listData" v-bind:key="i">
                  <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                  <td style="width:45px;text-align:center;">
                    <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                      <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                    </a>
                  </td>
                  <td style="text-align:left;" nowrap>{{ row.name }}</td>
                  <td style="text-align:center;"><input type="checkbox" :checked= row.using_passcode></td>
                  <td hidden>{{ row.id }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="box-footer">
            <div class="form-group">
              <label style="width:25px;text-align:right;">
                  <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
              </label>
              <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
              </label>
              <label>
                  Page
              </label>
              <label>
                  <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
              </label>
              <label id="TotalPageText">
                {{ totalPages }}                
              </label>
              <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
              </label>
              <label style="width:25px;text-align:left;">
                  <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_VIEW = 'read'
// const MODE_UPDATE = 'update'

export default {
  name: 'PaymentMethod',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'name'
      },
      tabActive: '',
      showValidFrom: false
    }
  },
  computed: {
  },
  created() {
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      var keyWords = evt.target.value
      var whereClause = ['name', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    inquiry() {
      let url = config.environment === 'Local' ? '/api/Gate/InquiryPaymentMethod?WhereClause=' : '/api/Gate/' + this.$store.state.userInfo.projects[0] + '/InquiryPaymentMethod?WhereClause='
      api
        .request('Gate', 'get', url + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onDisplay(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.$route.name
      }
      this.$router.push({ name: 'PaymentMethodForm', params: params })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PaymentMethod.vue?41ea5f10